import classNames from 'classnames';
import { Button as ReactAriaButton, type ButtonProps as ReactAriaButtonProps } from 'react-aria-components/Button';

import css from './Button.css';

interface ButtonProps
  extends Pick<
    ReactAriaButtonProps,
    | Extract<keyof ReactAriaButtonProps, `aria-${string}`>
    | 'autoFocus'
    | 'id'
    | 'isDisabled'
    | 'isPending'
    | 'slot'
    | 'type'
  > {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  size?: 'small' | 'medium';
  theme?: 'primary' | 'secondary';
  variant?: 'ghost' | 'outline' | 'solid';
}

const Button = ({
  className,
  onClick,
  size = 'medium',
  theme = 'primary',
  variant = 'outline',
  ...props
}: ButtonProps) => {
  return (
    <ReactAriaButton
      {...props}
      className={classNames(css.root, css[size], css[theme], css[variant], className)}
      onPress={onClick}
    />
  );
};

export default Button;
